{
  "Capability": "Capacidade",
  "CapabilityEnabled": "Ativado",
  "AvailableTelServers": "Que tipos de servidores de telefonia estão disponíveis?",
  "AvailableLicences": "Que tipos de licenças de sítio estão disponíveis?",
  "Broadworks": "Cisco Broadworks",
  "Webex": "Chamada Webex",
  "LegacyTelephony": "Legado ^^(Broadsoft M6, Panasonic, Siemens)^^",
  "Legacy": "Legado ^^(ONE, Presença, Lite, 1000, 2000, 3000)^^",
  "Enterprise": "Empresa",
  "Teams": "MS Teams",
  "MaxTelsysCount": "Número máximo de servidores de telefonia neste CME",
  "NAME": "CMECapabilities",
  "CxAnalytics": "Análise de CX",
  "CxIntegration": "Integração CX"
}